import { connect } from 'react-redux';
import DisconnectNotificationBar from './DisconnectNotificationBar';
import * as socketActions from '../../middleware/socketActions';

const mapStateToProps = state => ({
  socketStatus: state.socket.status,
  maximumReconnectsReached: true, // TODO change back to the following once we fix our api timeout issue: state.socket.maximumReconnectsReached
});

const mapDispatchToProps = dispatch => ({
  reconnect: () => dispatch(socketActions.socketReconnect()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DisconnectNotificationBar);
